const sourceOptions = [
  {
    value: 'CLM',
    label: 'CLM',
  },
  {
    value: 'MYTRAVEL',
    label: 'MYTRAVEL',
  },
];
export default sourceOptions;
